import { Component, Input } from '@angular/core';
import { TextCleanPipe } from '../pipes/text-clean-pipe';
import { formatAnalysisText } from '../services/format-analysis-text';
import { splitInHalf } from '../array-utils';

export interface V3FinnetContentGridItem {
  title: string;
  text: string;
}

// FinnetWeb's reusable "mini grid": 2 columns with a vertical divider between them,
// collapsing to 1 column (no divider) below 850px — see v3-finnet-content-grid/CLAUDE.md.
// Splits `items` roughly in half by count (first half left, second half right), not by
// balancing rendered height, so the split is deterministic regardless of text length.
@Component({
  selector: 'app-v3-finnet-content-grid',
  templateUrl: './v3-finnet-content-grid.html',
  styleUrl: './v3-finnet-content-grid.scss',
  standalone: true,
  imports: [TextCleanPipe],
})
export class V3FinnetContentGrid {
  @Input() items: V3FinnetContentGridItem[] = [];

  // Plain getters, not computed() — items is a plain @Input(), and computed() only
  // tracks signal reads, so it would freeze at whatever items was on first read (same
  // pitfall documented on V3Root's isMainPage-dependent gates).
  get leftColumn(): V3FinnetContentGridItem[] {
    return splitInHalf(this.items)[0];
  }

  get rightColumn(): V3FinnetContentGridItem[] {
    return splitInHalf(this.items)[1];
  }

  readonly formatText = formatAnalysisText;
}
